import { Controller } from "@hotwired/stimulus";
import renderResourceChip from "./resource_link_renderer";

// Renders a sent user message's context_items as linked pills at the top of the bubble, using the same
// resource chip markup as links inside Mo's replies (renderResourceChip).
export default class extends Controller {
  static values = { items: Array };

  connect() {
    this.element.innerHTML = this.itemsValue
      .filter((item) => item.label)
      .map((item) => {
        const text = item.sublabel ? `${item.label} · ${item.sublabel}` : item.label;
        return renderResourceChip(text, item.url, item.type);
      })
      .join("");
  }
}
